import i18n, { save } from "@/i18n";
import pageStyle from "./index.module.less";
export default {
    name: "Language",
    data() {
        return { i18n, pageStyle };
    },
    watch: {
        "i18n.locale"(value) {
            save(value); // 这里暂时没想到好办法去放在 i18n 里面一起处理
        }
    }
};
